import * as _4 from 'lodash4';
angular.module('capability-ng-smartcatalog').config(($urlRouterProvider: ng.ui.IUrlRouterProvider) => {
  const isValidState = (state: string | undefined) => {
    return (
      state &&
      (_4.includes(state, 'my.planner.plan.default') ||
        _4.includes(state, 'ap-advisor.plan.edit.default') ||
        _4.includes(state, 'ap-advisor.plan.view.default') ||
        _4.includes(state, 'my.planner.plan.coursegroup') ||
        _4.includes(state, 'ap-advisor.plan.view.coursegroup') ||
        _4.includes(state, 'ap-advisor.plan.edit.coursegroup'))
    );
  };
  const matchCallback = ($match: any, $stateParams: ng.ui.IStateParamsService, $state: ng.ui.IStateService) => {
    if (!_4.isEmpty($match.courseNk) && $state.current.name && isValidState($state.current.name)) {
      if (_4.includes($state.current.name, 'smart_course_details')) {
        $state.go('^.smart_course_details', { courseDetails: { ...$match, allowAddToTerm: true } });
      } else if (_4.includes($state.current.name, 'coursegroup')) {
        if (_4.includes($state.current.name, 'course_details')) {
          $state.go('^.course_details', { courseDetails: { ...$match, isFromSmartCat: true } });
        } else {
          $state.go('.course_details', { courseDetails: { ...$match, isFromSmartCat: true } });
        }
      } else {
        $state.go('.smart_course_details', { courseDetails: { ...$match, allowAddToTerm: true } });
      }
    }
  };
  $urlRouterProvider.when('/my/planner/plan/default/smart_course_details/:courseNk/', matchCallback);
  $urlRouterProvider.when('/my/planner/plan/default/smart_course_details/:courseNk', matchCallback);
  $urlRouterProvider.when('/advisor/plan/view/default/smart_course_details/:courseNk/', matchCallback);
  $urlRouterProvider.when('/advisor/plan/view/default/smart_course_details/:courseNk', matchCallback);
  $urlRouterProvider.when('/advisor/plan/edit/default/smart_course_details/:courseNk/', matchCallback);
  $urlRouterProvider.when('/advisor/plan/edit/default/smart_course_details/:courseNk', matchCallback);
  $urlRouterProvider.when('/my/planner/plan/coursegroup/:termId/:slotId/smart_course_details/:courseNk', matchCallback);
  $urlRouterProvider.when(
    '/advisor/plan/view/coursegroup/:termId/:slotId/smart_course_details/:courseNk',
    matchCallback
  );
  $urlRouterProvider.when(
    '/advisor/plan/edit/coursegroup/:termId/:slotId/smart_course_details/:courseNk',
    matchCallback
  );
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/configuration/smart_catalog_module_config.ts